







import { defineComponent } from '@nuxtjs/composition-api'
import useProductPage from '~/composables/useProductPage';
import SwitchVue from '~/components/Switch.vue';
import { merge } from 'lodash-es';
import { CONFIGURABLE_TYPE_ID, DURATION_MATCHING } from '~/utils/constants/product';

export default defineComponent({
    components:{
        SwitchVue
    },
    setup() {
        const {product,productLowPaymentFrequency, productHighPaymentFrequency, setPaymentFrequencyChoosen, paymentFrequencyChoosen, showPaymentFrequencySwitcher, setAddToCartConfigs, addToCartConfigs} = useProductPage()
        /**
         * For Configurable items, If the item has only one payment frequency set that option for add to cart on setup (the bundle has the payment frequency set as bundle option, not product option)
         */
         let pfAttribute = null;
         let pfValues = {} /** mapping pf uids, ex : { 'M': 'Y29uZmlndXJhYmxlLzE2MzYvMTU0', 'Y':'Y29uZmlndXJhYmxlLzE1My8xMg=='} */
        if(product.value.productTypeId==CONFIGURABLE_TYPE_ID){
            pfAttribute = product.value.configurable_options.find(el=>el.attribute_code=='tipo_abbonamento');
            if(pfAttribute){
                pfAttribute.values.forEach(opt => pfValues[DURATION_MATCHING[opt.value_index]] = opt.uid )
                if(productLowPaymentFrequency.value==productHighPaymentFrequency.value){
                    let newCartConfig = Object.assign({}, addToCartConfigs.value);
                    newCartConfig[pfAttribute.attribute_uid] = pfValues[productLowPaymentFrequency.value]
                    setAddToCartConfigs(merge({}, newCartConfig));
                }
            }
        }

        const changePf = val=>{
            if(product.value.productTypeId==CONFIGURABLE_TYPE_ID){
                if(pfAttribute && pfAttribute.attribute_uid){
                    let newCartConfig = Object.assign({}, addToCartConfigs.value);
                    newCartConfig[pfAttribute.attribute_uid] = pfValues[val]
                    setAddToCartConfigs(merge({}, newCartConfig));
                }
            }
            setPaymentFrequencyChoosen(val)
        }
        if(product.value.productTypeId==CONFIGURABLE_TYPE_ID) changePf(productHighPaymentFrequency.value)
        return {
            productLowPaymentFrequency, productHighPaymentFrequency, setPaymentFrequencyChoosen, paymentFrequencyChoosen, showPaymentFrequencySwitcher,
            disabled : productLowPaymentFrequency.value==productHighPaymentFrequency.value,
            changePf
        }
    },
})
